import * as yup from 'yup';

import {
    firstNameValidationRule,
    lastNameValidationRule,
} from './validationRules';

export const edmSchema = yup.object({
    firstName: firstNameValidationRule,
    lastName: lastNameValidationRule,
    dateOfBirth: yup.string(),
    phones: yup.array(),
    emails: yup.array(),
    addresses: yup.array().of(
        yup.object().shape({
            address: yup.string(),
            city: yup.string(),
            state: yup.string(),
            zip: yup.string(),
        })
    ),
});
